import React from 'react';
import PropTypes from 'prop-types';
import { Trans, t } from '@lingui/macro';
import { I18n } from '@lingui/react';
import { RenderField } from '@oms/ui-field';
import { NumberInput } from '@oms/ui-number-input';
import { Select } from '@oms/ui-select';
import { Button } from '@oms/ui-button';
import { Stack } from '@oms/ui-stack';

class TechnicalIndicatorSelect extends React.Component {
  static propTypes = {
    addTechnicalIndicator: PropTypes.func.isRequired,
  };

  state = {
    interval: 14,
    indicator: '',
  };

  handleIndicatorChange = (indicator) => {
    this.setState({ indicator });
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleSubmit = (event) => {
    const { indicator, interval } = this.state;
    const { addTechnicalIndicator } = this.props;

    event.preventDefault();

    if (!interval || !indicator) return;

    addTechnicalIndicator(indicator.value, interval);
  };

  render() {
    const { interval } = this.state;

    /* eslint-disable jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for */
    return (
      <I18n>
        {({ i18n }) => {
          const i18nToString = (message) =>
            i18n ? i18n._(message) : message.id;

          const technicalOptions = [
            {
              value: 'sma',
              label: i18nToString(t`Simple moving average (SMA)`),
            },
            {
              value: 'ema',
              label: i18nToString(t`Exponential moving average (EMA)`),
            },
            { value: 'wma', label: i18nToString(t`Weighted average (WMA)`) },
            {
              value: 'rsi',
              label: i18nToString(t`Relative strength index (RSI)`),
            },
            { value: 'momentum', label: i18nToString(t`Momentum`) },
            { value: 'roc', label: i18nToString(t`Rate of change (ROC)`) },
            { value: 'bb', label: i18nToString(t`Bollinger Bands`) },
            { value: 'priceenvelopes', label: i18nToString(t`Envelope`) },
            {
              value: 'stochastic',
              label: i18nToString(t`Stochastic oscillator (%K,%D)`),
            },
          ];

          const selectPlaceholder = i18nToString(t`Select`);
          const intervalPlaceholder = i18nToString(t`Interval`);

          return (
            <Stack as="form" onSubmit={this.handleSubmit} gap={3}>
              <RenderField
                as={Select}
                name="indicator"
                label={<Trans>Analysis</Trans>}
                placeholder={selectPlaceholder}
                value={this.state?.indicator}
                onChange={this.handleIndicatorChange}
                items={technicalOptions}
              />
              <RenderField
                as={NumberInput}
                name="interval"
                label={<Trans>Interval</Trans>}
                placeholder={intervalPlaceholder}
                value={interval}
                onChange={this.handleChange}
              />
              <Button type="submit">
                <Trans>Add</Trans>
              </Button>
            </Stack>
          );
        }}
      </I18n>
    );
  }
}

export default TechnicalIndicatorSelect;
